import envDev from './env.dev';
import envHomolog from './env.homolog';
import envLocal from './env.local';
import envRelease from './env.release';

export const version = `${window.__RUNTIME_CONFIG__.REACT_APP_DEPLOY || 'DEV'}-0.0.1`;
export const APP_ENV_RELEASE = version.toUpperCase().includes('PRD');
export const APP_ENV_HOMOLOG = version.toUpperCase().includes('HML');
export const APP_ENV_DEVELOP = version.toUpperCase().includes('DEV');
export const APP_ENV_LOCAL = !version.toUpperCase().includes('PRD') && !version.toUpperCase().includes('HML') && !version.toUpperCase().includes('DEV');

export const AMBIENTE_NOT_RELEASE = APP_ENV_HOMOLOG?'HOMOLOGAÇÂO':APP_ENV_DEVELOP?'DESENVOLVIMENTO':APP_ENV_LOCAL?'LOCAL':'';

const env = (() => {
  if (APP_ENV_RELEASE) {
    return envRelease;
  }
  if (APP_ENV_HOMOLOG) {
    return envHomolog;
  }
  if (APP_ENV_DEVELOP) {
    return envDev;
  }
  return envLocal;
})();

export default env;
